import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var PricingTypes = Object.freeze({
  TOTAL_TIER: 'TOTAL_TIER',
  PER_UNIT_TIER: 'PER_UNIT_TIER'
});
export var getTierDescription = function getTierDescription(priceType, unitCount) {
  var prevUnitCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (unitCount === -1 && prevUnitCount === 5000) {
    return 'Unlimited users';
  } else if (unitCount === -1) {
    // In case of 20k , last 2 tier difference is 5k, it will be same for further new upcoming tiers ( 25k, 30k , 35k , 40k , 45k and 50k ).
    // Instead of showing unlimited, last tier should be 15001 to 20000 users
    return "".concat(prevUnitCount + 1, " - ").concat(prevUnitCount + 5000, " users");
  }

  if (priceType === PricingTypes.TOTAL_TIER) {
    return "".concat(unitCount, " users");
  }

  return "".concat(prevUnitCount + 1, " - ").concat(unitCount, " users");
};

var getFlattenedAppPrice = function getFlattenedAppPrice(appsPricing) {
  return appsPricing.map(function (pricing) {
    var priceType = pricing.perUnitItems ? PricingTypes.PER_UNIT_TIER : PricingTypes.TOTAL_TIER;
    var priceItems = pricing.perUnitItems || pricing.items;
    var flattenAppsPricing = priceItems.map(function (item, index) {
      return getAppData(priceType, item, index === 0 ? 0 : priceItems[index - 1].unitCount);
    });

    if (priceType === PricingTypes.PER_UNIT_TIER) {
      flattenAppsPricing.unshift(getAppData(PricingTypes.TOTAL_TIER, pricing.items[0]));
    }

    function getAppData(PricingType, item, prevUnitCount) {
      return {
        priceType: PricingType,
        unitCount: item.unitCount,
        amount: item.localCurrencyAmount,
        description: getTierDescription(PricingType, item.unitCount, prevUnitCount),
        localCurrency: item.localCurrency
      };
    }

    return flattenAppsPricing;
  });
};

var getAppsTotalPricing = function getAppsTotalPricing(flattenAppPrice) {
  return flattenAppPrice.reduce(function (accumulatedPrice, currentPrice) {
    return accumulatedPrice.map(function (price, index) {
      return _objectSpread(_objectSpread({}, price), {}, {
        amount: price.amount + currentPrice[index].amount
      });
    });
  });
};

export var applyFlatDiscount = function applyFlatDiscount(appsTotalPrice, flatDiscount) {
  var previousMaxTierPrice;
  var previousUnitCount; // in case of 10k or 20k , last 2 tier difference is 5k, it will be same for further new tiers whenever added

  var lastTwoTierDifference = 5000;
  return appsTotalPrice.map(function (priceItem) {
    var maxTieredAmount = priceItem.amount;

    if (priceItem.priceType === PricingTypes.PER_UNIT_TIER) {
      var currentUnitCount = priceItem.unitCount === -1 ? lastTwoTierDifference + previousUnitCount : priceItem.unitCount;

      if (previousUnitCount && previousMaxTierPrice) {
        maxTieredAmount = previousMaxTierPrice + (currentUnitCount - previousUnitCount) * priceItem.amount;
      } else {
        maxTieredAmount = currentUnitCount * priceItem.amount;
      }

      previousUnitCount = priceItem.unitCount;
    }

    previousMaxTierPrice = maxTieredAmount;
    var discountAmount = maxTieredAmount * flatDiscount / 100;
    return _objectSpread(_objectSpread({}, priceItem), {}, {
      discountPercentage: flatDiscount,
      discountAmount: discountAmount,
      totalAmount: maxTieredAmount - discountAmount
    });
  });
};
export var getAppsPricingWithDiscount = function getAppsPricingWithDiscount(appsPricing, flatDiscount) {
  var flattenAppPrice = getFlattenedAppPrice(appsPricing);
  var appsTotalPrice = getAppsTotalPricing(flattenAppPrice);
  return applyFlatDiscount(appsTotalPrice, flatDiscount);
};